import { render } from "./RashaCorti.vue?vue&type=template&id=56c1d174"
import script from "./RashaCorti.vue?vue&type=script&lang=js"
export * from "./RashaCorti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__